<head>
<script src="https://unpkg.com/vue"></script>
</head>
<template>
  <a-card title="Cadastro de Pista de Corrida">
    <form ref="form" @submit.prevent="submitForm">
      <div key="unidade" class="row">
        <div class="col-md-8">
          <label for="unidade">Unidade de Atendimento</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>
          <br />
          <a-auto-complete v-model:value="registro.unidadeAtendimento.descricao" @search="handleSearch" class="form-control border-left-0">
            <template v-slot:dataSource>
              <a-select-option v-for="item in unidadesFiltro" :key="item.descricao" @click="onSelect(item)">
                {{ item.descricao }}
              </a-select-option>
            </template>
          </a-auto-complete>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <label for="tamanhoEmMetro">Tamanho em Metros</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>
          <br />
          <input v-model="registro.tamanhoEmMetro" type="number" class="form-control form-input-component" required />
        </div>
        <div class="col-md-4">
          <div>
            <label for="status">Status</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>
            <br />
            <select v-model="registro.situacao" class="form-select form-input-component" required>
              <option value="ATIVO">Ativo</option>
              <option value="INATIVO">Inativo</option>
            </select>
          </div>
        </div>
      </div>
      <a-divider type="horizontal" />
      <div class="spaced-container">
        <button type="submit" class="btn btn-primary" @click="cadastrar">Salvar</button>
        <button class="btn btn-warning" @click="voltar">Voltar</button>
      </div>
    </form>
  </a-card>
</template>

<script>
import { openNotification, typesNotification } from '@/utils/notifications';
import { create, getById } from '@/components/service/pistaCorridaService';

import { getUnidadeAtendimento } from '@/config/servicos-utils';

export default {
  name: 'FormManterPistaCorrida',
  setup() {
    return {};
  },
  data() {
    return {
      registro: { unidadeAtendimento: { id: null, descricao: null }, prazo: null, situacao: null },
      unidades: [],
      unidadesFiltro: [],
    };
  },
  methods: {
    async cadastrar() {
      //this.v$.$validate()
      if (!this.$refs.form.checkValidity() || this.registro.unidadeAtendimento.id === null) {
        this.submitted = true;
        openNotification(typesNotification.warning, 'Informe os campos obrigatórios!');
      } else {
        await create(this.registro).then(() => {
          //let retorno = r.data;
          if (!this.registro.id) {
            openNotification(typesNotification.success, 'Dados salvos com sucesso.');
          } else {
            openNotification(typesNotification.success, 'Dados alterados com sucesso.');
          }
          this.submitted = true;
          this.registro = { unidadeAtendimento: { id: null, descricao: null }, prazo: null, situacao: null };
        });
      }
    },
    voltar() {
      this.$router.go(-1);
    },
    async carregarPistaCorrida() {
      if (this.$route.query.id) {
        const idUrl = this.$route.query.id;
        const res = await getById(idUrl);
        this.registro = { ...res.data, id: idUrl };
      }
    },
    onSelect(value) {
      this.registro.unidadeAtendimento = { id: value.id, descricao: value.descricao };
    },
    async getUnidade() {
      await getUnidadeAtendimento().then((r) => {
        r.data.forEach((unidade) => {
          this.unidades.push({ ...unidade, descricao: unidade.descricao.toUpperCase() });
        });
      });
    },
    async handleSearch(value) {
      if (value.length >= 2) {
        this.unidadesFiltro = this.unidades.filter((unidade) => unidade.descricao.toUpperCase().includes(value.toUpperCase()));
      } else {
        this.unidadesFiltro = [];
      }
    },
  },

  created() {
    this.carregarPistaCorrida();
    this.getUnidade();
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}

.h2 {
  font-size: x-large;
}

.spaced-container * {
  margin-top: 10px;
  margin-right: 10px;
}
</style>
